import { LoginDialog } from '../auth/login/loginDialog';
import { BrowserRouter } from 'react-router-dom';
import { RootState } from '../../redux/store';
import GetParameterPopups from '../../popups';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { HomeBar } from '../appBars/homeBar/homeBar';
import { CategoriesAppBar } from '../categories/categoriesAppBar';
import { SocialNetworkBar } from '../appBars/socialNetworksBar/socialNetworkBar';
import MenuDrawer from '../menu/menuDrawer';
import { CopyrightBar } from '../appBars/copyrightBar/copyrightBar';
import { resetLoginRequired } from '../../redux/reducers/authReducer';
import { CookiesBar } from '../cookies/cookiesBar';
import { PasswordChange } from '../auth/accountSettings/passwordChange';
import { useEffect, useState } from 'react';
import WebsiteRoutes from '../../routes/websiteRoutes';
import { Box, Container } from '@mui/material';
import { env } from '../../env';
import ScrollToTop from './scrollToTop';
import { CompanyName } from '../../helpers/clientConfigs';
import { DefaultWebsiteRoutes, FormadaRoutes } from '../../routes/allRoutes';
import CartDrawer from '../shoppingCart/cartDrawer';
import { OmnisendScript } from '../../integrations/omnisend/OmnisendScript';
import { GoogleTagScript } from '../../integrations/google/GoogleTagScript';
import { GooglePayScript } from '../../integrations/google/GooglePayScript';
import { FacebookAppMeta } from '../../integrations/facebook/FacebookAppMeta';
import { MetaPixelScript } from '../../integrations/facebook/MetaPixelScript';
import { trackersRunner } from '../../integrations/trackersRunner';
import { InternalTracker } from '../../integrations/internal/internalTracker';
import { PhoneConfirmationRedirect } from '../../routes/phoneConfirmationRedirect';

function WebsiteContent() {
  var dispatch = useAppDispatch();
  const isLoginRequired: boolean = useAppSelector((state: RootState) => state.authState.isLoginRequired);
  const isUserLoggedIn = useAppSelector((state: RootState) => state.authState.isLoggedIn);
  const isPasswordRestored = useAppSelector((state: RootState) => state.authState.isPasswordRestored);
  const baseUrl = env.PUBLIC_URL ?? '';
  const [openPasswordChange, setOpenPasswordChange] = useState(false);

  const closeLogin = () => {
    dispatch(resetLoginRequired());
  };

  useEffect(() => {
    let ogUrlMeta = document.querySelector("meta[property='og:url']");
    if (ogUrlMeta) {
      ogUrlMeta.setAttribute('content', window.location.href);
    }
    trackersRunner.register(new InternalTracker());
  }, []);

  useEffect(() => {
    if (isPasswordRestored) {
      if (isUserLoggedIn) {
        setOpenPasswordChange(true);
      }
    } else {
      setOpenPasswordChange(false);
    }
  }, [isPasswordRestored, isUserLoggedIn]);

  const closePasswordChange = () => {
    setOpenPasswordChange(false);
  };

  const getRoutes = () => {
    return CompanyName === 'FORMADA' ? FormadaRoutes : DefaultWebsiteRoutes;
  };

  return (
    <Box sx={{ backgroundColor: 'rootContainer.background', color: 'rootContainer.color' }}>
      <Container
        disableGutters
        maxWidth="xl"
        sx={{ minWidth: '300px', px: '24px', '@media (max-width: 600px)': { px: '12px' } }}
      >
        <BrowserRouter basename={baseUrl}>
          <OmnisendScript />
          <GoogleTagScript />
          <GooglePayScript />
          <MetaPixelScript />
          <FacebookAppMeta />
          <ScrollToTop />
          <MenuDrawer />
          <CartDrawer />
          <HomeBar />
          <PhoneConfirmationRedirect />
          <Box
            sx={{
              pt: '100px',
              '@media (max-width: 400px)': {
                pt: '160px',
              },
              '@media (min-width: 401px) and (max-width: 700px)': {
                pt: '150px',
              },
              '@media (min-width: 701px) and (max-width: 1399px)': {
                pt: '100px',
              },
              '@media (min-width: 1400px)': {
                pt: '145px',
              },
            }}
          >
            <CategoriesAppBar />
            <WebsiteRoutes routes={getRoutes()} />
            <SocialNetworkBar />
            <CopyrightBar />
          </Box>
          <GetParameterPopups />
          <LoginDialog open={isLoginRequired} onClose={closeLogin} />
          <CookiesBar />
          <PasswordChange open={openPasswordChange} onClose={closePasswordChange} />
        </BrowserRouter>
      </Container>
    </Box>
  );
}
export default WebsiteContent;
